"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TaxOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M7 8h6a1 1 0 000-2H7a1 1 0 000 2zM12.29 25.71a1 1 0 001.42 0l6-6a1 1 0 00-1.42-1.42l-6 6a1 1 0 000 1.42z"/><circle cx="13" cy="19" r="1"/><circle cx="19" cy="25" r="1"/><path d="M9 10H7a1 1 0 000 2h2a1 1 0 000-2z"/><path d="M26 2H6C3.5 2 2 3.87 2 7v21a2 2 0 002 2h18a2 2 0 002-2V7c0-2.8 1.68-3 2-3 .08 0 2 0 2 3a3.44 3.44 0 01-2.32 3.05 1 1 0 10.64 1.9C26.47 11.9 30 10.68 30 7c0-4-2.62-5-4-5zm-4 5v21H4V7c0-3 1.5-3 2-3h16.7a5.93 5.93 0 00-.7 3z"/>';
var TaxOutlineSVG = function TaxOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.TaxOutlineSVG = TaxOutlineSVG;
TaxOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TaxOutlineSVG);
exports.default = _default;